(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-option-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const offerButtons = document.querySelectorAll('.offer-card');

  // Déclencher la sélection de l'offre active par défaut
  const defaultActiveButton = document.querySelector('.offer-card.is-active');
  if (defaultActiveButton) {
    triggerOfferSelection(defaultActiveButton);
  }

  offerButtons.forEach(button => {
    button.addEventListener('click', () => {
      triggerOfferSelection(button);
    });
  });

  function triggerOfferSelection(button) {
    const variantId = button.getAttribute('data-variant-id');
    const variantId2 = button.getAttribute('data-variant-id-2');
    const text = button.getAttribute('data-cure-text');
    const qty = button.getAttribute('data-qty');

    const cureEl = document.getElementById("cure-duration-text");
    if (cureEl) cureEl.textContent = text;

    const qtyTargets = document.querySelectorAll('[data-quantity-default-item]');
    qtyTargets.forEach(target => {
      const baseQty = Number(target.getAttribute('data-quantity-default-item'));
      const newQty = baseQty * qty;

      target.setAttribute('data-quantity-default-item', baseQty);
      target.setAttribute('data-quantity', newQty);
      target.textContent = newQty;
    });

    if (variantId) {
      const radio1 = document.querySelector(`input[type="radio"][data-option-value-id="${variantId}"]`);
      if (radio1) {
        radio1.checked = true;
        radio1.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (variantId2 && variantId2 !== "0") {
      const radio2 = document.querySelector(`input[type="radio"][data-option-value-id="${variantId2}"]`);
      if (radio2) {
        radio2.checked = true;
        radio2.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    offerButtons.forEach(btn => {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-checked', 'false');
    });

    button.classList.add('is-active');
    button.setAttribute('aria-checked', 'true');
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-variant-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const offerButtons = document.querySelectorAll('.offer-card');

  // Déclencher la sélection de l'offre active par défaut
  const defaultActiveButton = document.querySelector('.offer-card.is-active');
  if (defaultActiveButton) {
    triggerOfferSelection(defaultActiveButton);
  }

  offerButtons.forEach(button => {
    button.addEventListener('click', () => {
      triggerOfferSelection(button);
    });
  });

  function triggerOfferSelection(button) {
    const variantId = button.getAttribute('data-variant-id');
    const variantId2 = button.getAttribute('data-variant-id-2');
    const text = button.getAttribute('data-cure-text');
    const qty = Number(button.getAttribute('data-qty')) || 1;

    const cureEl = document.getElementById("cure-duration-text");
    if (cureEl) cureEl.textContent = text;

    const qtyTargets = document.querySelectorAll('[data-quantity-default-item]');
    qtyTargets.forEach(target => {
      const baseQty = Number(target.getAttribute('data-quantity-default-item'));
      const newQty = baseQty * qty;

      target.setAttribute('data-quantity-default-item', baseQty);
      target.setAttribute('data-quantity', newQty);
      target.textContent = newQty;
    });

    if (variantId) {
      const radio1 = document.querySelector(`input[type="radio"][data-variant-id="${variantId}"]`);
      if (radio1) {
        radio1.checked = true;
        radio1.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (variantId2 && variantId2 !== "0") {
      const radio2 = document.querySelector(`input[type="radio"][data-variant-id="${variantId2}"]`);
      if (radio2) {
        radio2.checked = true;
        radio2.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    offerButtons.forEach(btn => {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-checked', 'false');
    });

    button.classList.add('is-active');
    button.setAttribute('aria-checked', 'true');
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-breaker-selector"] && !Shopify.designMode) return;
  try {
    (function() {
  const form = document.getElementById('offer-atc-form');
  if (!form) return;

  const qtyInput = form.querySelector('.quantity-input');
  const cards = form.querySelectorAll('.offer-card');

  // Debug au chargement
  console.log('Form trouvé:', form);
  console.log('Quantity input trouvé:', qtyInput);
  console.log('Valeur initiale:', qtyInput ? qtyInput.value : 'N/A');

  cards.forEach(card => {
    card.addEventListener('click', function(e) {
      if (this.disabled) return;
      
      cards.forEach(c => c.classList.remove('is-active'));
      this.classList.add('is-active');
      
      if (qtyInput) {
        qtyInput.value = this.dataset.quantity;
        console.log('Nouvelle quantité définie:', qtyInput.value);
        console.log('Attribut name de l\'input:', qtyInput.name);
        console.log('Données du formulaire:', new FormData(form));
      }
    });
  });

  // Intercepter la soumission du formulaire pour debug
  form.addEventListener('submit', function(e) {
    console.log('Soumission du formulaire...');
    console.log('Quantité au moment de la soumission:', qtyInput.value);
    const formData = new FormData(form);
    for (let [key, value] of formData.entries()) {
      console.log(key + ':', value);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
